import { FC, Fragment, useEffect } from 'react';
import { replace } from 'connected-react-router';
import { useTranslation } from 'react-i18next';
// Models
import { RootState } from 'app/store';
// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Async
import { getTermsAndConditions } from 'app/store/Terms/Terms.async';
import { acceptTermsAndConditions } from 'app/store/Users/Users.async';
// Selectors
import { selectRequestedUrl } from 'app/store/AppUI/AppUI.selectors';
import { selectLoading, selectPendingTermsAndConditionsByScope, selectCurrentTermsAndConditions } from 'app/store/Users/Users.selectors';
// Mui
import { Toolbar, Typography, Box, Paper, Container } from '@mui/material';
// Components
import Header from 'app/components/Header';
import { Button } from 'app/components/Mui';

const TermsAndConditionsPage:FC = () => {
  const { t } = useTranslation();
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const requestedUrl = useAppSelector(selectRequestedUrl);
  const loading = useAppSelector(selectLoading);
  const pendingTermsAndConditions = useAppSelector((state:RootState) => selectPendingTermsAndConditionsByScope(state, {
    scope: 'general'
  }));
  const currentTermsAndConditions = useAppSelector((state:RootState) => selectCurrentTermsAndConditions(state, {
    scope: 'general'
  }));

  useEffect(() => {
    if ( !pendingTermsAndConditions || !pendingTermsAndConditions.length ) return;
    const ids = pendingTermsAndConditions.map((pedingTerms:any) => pedingTerms.id);
    const params = { ids: ids.join(','), owners: 'self,platform' };
    dispatch(getTermsAndConditions(params));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if ( !pendingTermsAndConditions || !pendingTermsAndConditions.length ){
      dispatch(replace(requestedUrl || '/'));
    }
    // eslint-disable-next-line
  }, [pendingTermsAndConditions]);

  const handleClick = () => {
    if ( !currentTermsAndConditions ) return;
    dispatch(acceptTermsAndConditions(currentTermsAndConditions.id));
  }

  if ( !currentTermsAndConditions ) return null;
  return (
    <Fragment>
      <Header />
      <Toolbar variant="dense">
        <Typography variant="h6">{t('pages.termsAndConditions.title')}</Typography>
      </Toolbar>
      <Box sx={{ display: 'flex', flexGrow: 1, overflow: 'hidden' }} react-action="scroll">
        <Container sx={{ display: 'flex', flexDirection: 'column', py: 4 }} maxWidth="md">
          <Paper
            sx={{ flexGrow: 1, p: 4, overflowY: 'auto', whiteSpace: 'break-spaces' }}
            className="ql-editor preview"
            dangerouslySetInnerHTML={{ __html: currentTermsAndConditions.content }}
          />
          <Box sx={{ pt: 4, textAlign: 'center' }}>
            <Button
              name="Accept terms and conditions"
              loading={loading}
              onClick={handleClick}
              color="primary"
              variant="contained"
            >{t('buttons.accept')}</Button>
          </Box>
        </Container>
      </Box>
    </Fragment>
  )
}

export default TermsAndConditionsPage;
